import apiClient from '@/api/apiClient'
import { setAuthCredentials, clearAuthCookies } from '@/helpers/auth'

export const parseAPIErrorResponse = error => {
  if (error?.response?.data?.message) return error.response.data.message
  if (error?.response?.data?.errors?.length)
    return error.response.data.errors[0]
  return error?.message
}

export const login = async credentials => {
  try {
    const response = await apiClient.post('auth/sign_in', credentials)
    setAuthCredentials(response)
    window.location = '/app'
    return null
  } catch (error) {
    throw new Error(parseAPIErrorResponse(error))
  }
}

export const validityCheck = () => apiClient.get('auth/validate_token')

export const logout = async () => {
  try {
    await apiClient.delete('auth/sign_out')
  } finally {
    clearAuthCookies()
    window.location = '/app/login'
  }
}

export const validatePasswordToken = token =>
  apiClient.get('api/v1/password_setup', { params: { token } })

export const setPasswordByToken = payload =>
  apiClient.patch('api/v1/password_setup', payload)
